import { render, staticRenderFns } from "./AttendanceItemsGroup.vue?vue&type=template&id=645fa8d2"
import script from "./AttendanceItemsGroup.vue?vue&type=script&lang=js"
export * from "./AttendanceItemsGroup.vue?vue&type=script&lang=js"
import style0 from "./AttendanceItemsGroup.vue?vue&type=style&index=0&id=645fa8d2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QIntersection from 'quasar/src/components/intersection/QIntersection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTabs,QTab,QBadge,QTabPanels,QTabPanel,QIntersection});
